"use client";

import { useCallback, useRef } from "react";
import Link from "next/link";
import SwiperComponent from "@/components/ui/swiper-component";
import MediaComponent from "@core/helpers/server/components/image";
import { slide_link_props } from "@/helpers/slideLabel";

// Must stay identical to the height in index.server.jsx: the server markup is
// swapped for this component right after hydration, and any difference in
// height shows up as layout shift at the very top of the home page.
const SLIDE_BOX = "w-full h-64 lg:h-[400px]";

export default function HomeTopSliderClient({ slider_data, storage_prefix_url }) {
    const video_refs = useRef([]);

    // Every slide used to carry `autoPlay`, so all of the videos (~1MB each)
    // started downloading together. Only the slide in view plays.
    const play_only = useCallback((active_index) => {
        video_refs.current.forEach((video, index) => {
            if (!video) return;
            if (index === active_index) {
                video.play?.()?.catch?.(() => { });
            } else {
                video.pause?.();
            }
        });
    }, []);

    const slides = (slider_data?.images || []).map((card, index) => (
        <Link
            href={card?.link?.url || ""}
            key={`home-first-slider-${index}`}
            className="block w-full"
            {...slide_link_props(card, `اسلاید ${index + 1}`)}>

            <div className={SLIDE_BOX}>
                {
                    card?.slide_type === 2 ?
                        <video
                            ref={(el) => { video_refs.current[index] = el; }}
                            className="w-full h-full object-cover"
                            src={`${storage_prefix_url}/${card?.media?.url}`}
                            autoPlay={index === 0}
                            preload={index === 0 ? "metadata" : "none"}
                            loop
                            muted
                            playsInline
                        />
                        :
                        <MediaComponent
                            storage_prefix_url={storage_prefix_url}
                            src={card?.media?.url}
                            alt={card?.media?.alt || ""}
                            width={1024}
                            height={400}
                            style={{ width: "100%", height: "100%" }}
                            className="object-cover"
                            // اسلاید اول LCP است، بقیه lazy؛ props با index.server.jsx یکی است تا همان فایل دوباره دانلود نشود
                            isLCP={index === 0}
                            // همان quality نسخه‌ی سرور (index.server.jsx)؛ core پیش‌فرض ۱۰۰ می‌گذارد
                            quality={75}
                        />
                }
            </div>
        </Link>
    ));


    return (

        <section className={SLIDE_BOX}>
            <SwiperComponent
                slides={slides}
                loop={true}
                autoplay={{
                    delay: 6000,
                    disableOnInteraction: false
                }}
                speed={900}
                pagination={{
                    clickable: true,
                    dynamicBullets: true,
                }}
                navigation={true}
                navPosition="bottom"
                hideNavOnMobile={true}
                grabCursor={true}
                onSlideChange={play_only}
                swiper_className="home-first-slider w-full h-full"
                style={{ width: "100%", height: "100%", }}
            />

        </section>

    );

}
